module.exports = __webpack_public_path__ + "img/3.a6f6a0ab.png";